import { Page } from '@optools/components/layout/page';
import { SubNavigationItem } from '@optools/components/layout/sub-navigation';
import { useAccessCheck } from '@optools/hooks/useAccessCheck';
import { selectToolsConfig } from '@optools/store/configApiSlice';
import { useAppSelector } from '@optools/store/hooks';
import { authorizedRouteLoader } from '@optools/utils/auth/authorized-route-loader';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/btc-tools')({
  beforeLoad: authorizedRouteLoader('btcTools'),
  component: RouteComponent,
});

function RouteComponent() {
  const { checkStreamingViewOnly } = useAccessCheck();
  const { btcTools } = useAppSelector(selectToolsConfig);
  const isViewOnly = checkStreamingViewOnly(btcTools.auth.groups);

  const links = isViewOnly
    ? [{ label: 'Schedule', to: '/btc-tools/schedule' } satisfies SubNavigationItem]
    : ([
        { label: 'Schedule', to: '/btc-tools/schedule' },
        {
          links: [
            { label: 'Pipeline', to: '/btc-tools/configs/pipeline' },
            { label: 'Pipeline Input', to: '/btc-tools/configs/pipeline-input' },
            { label: 'Skyview', to: '/btc-tools/configs/skyview' },
            { label: 'Multicast Mapping', to: '/btc-tools/configs/multicast-mappings' },
          ],
          title: 'Configs',
        },
        { label: 'CDN Status', to: '/btc-tools/cdn-status' },
        { label: 'Broadcast Source Overrides', to: '/btc-tools/broadcast-source-overrides' },
        { label: 'Team Zixi Sources', to: '/btc-tools/team-zixi-sources' },
      ] satisfies SubNavigationItem[]);

  return <Page links={links} title="BTC Tools" />;
}
